import type { BenchmarkGroupType } from '@app/src/types/benchmark'
import type { Provider } from '@app/src/types/organizations'
import { useMemo, useState } from 'react'
import { resolvePeerGroup } from './peerGroups'
import type { BenchmarkData } from './types'
import { useBenchmark } from './useBenchmark'

interface UseProfileBenchmarkResult {
  peerGroup: BenchmarkGroupType
  setPeerGroup: (peerGroup: BenchmarkGroupType) => void
  benchmark?: BenchmarkData
  peerCount?: number
  isLoading: boolean
}

export function useProfileBenchmark(provider: Provider): UseProfileBenchmarkResult {
  const [selectedPeerGroup, setPeerGroup] = useState<BenchmarkGroupType>()
  const peerGroup = useMemo(() => resolvePeerGroup(provider, selectedPeerGroup), [provider, selectedPeerGroup])
  const { benchmark, isLoading } = useBenchmark(provider.id, peerGroup)

  return {
    peerGroup,
    setPeerGroup,
    benchmark,
    peerCount: benchmark?.overall?.peerCount ?? benchmark?.integrity?.peerCount,
    isLoading,
  }
}
